// extracted by mini-css-extract-plugin
module.exports = {"root":"EndpointKitNode_root__1Obrw","title":"EndpointKitNode_title__7-cz_"};